import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { SettingsComponent } from '../shared-standalone/media-settings/settings.component';
import { DeviceService } from '../media/devices/device.service';
import { MediaTrackService } from '../media/track-ctrl/media-track.service';
import { MatCard, MatCardContent } from '@angular/material/card';
import { HeadingComponent } from '../shared/heading/heading.component';
import { SharedModule } from '../shared/shared.module';
import { VirtualBackgroundSettingsComponent } from '../shared-standalone/media-settings/virtual-background-settings/virtual-background-settings.component';
import { catchError, of, switchMap } from 'rxjs';
import { ProfileDataService } from '../services/data/profile-data.service';

@Component({
  selector: 'app-device-setup',
  imports: [
    SettingsComponent,
    MatCard,
    MatCardContent,
    HeadingComponent,
    SharedModule,
    VirtualBackgroundSettingsComponent,
  ],
  templateUrl: './device-setup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './device-setup.component.scss',
})
export class DeviceSetupComponent implements OnDestroy {
  constructor(
    private readonly deviceService: DeviceService,
    readonly mediaTrackService: MediaTrackService,
    private readonly profileDataService: ProfileDataService,
  ) {
    this.profileDataService
      .loadProfileDataForMedia()
      .pipe(
        catchError(() => of(null)),
        switchMap(() => mediaTrackService.initIfNotExists()),
      )
      .subscribe();
  }

  onSettingsChanged(deviceInfo?: MediaDeviceInfo) {
    if (deviceInfo) this.deviceService.changeSelectedDevice(deviceInfo);
  }

  ngOnDestroy() {
    this.mediaTrackService.clearTracks();
  }
}
